// const AJAX_URL = '/wp-admin/admin-ajax.php'

jQuery(document).foundation()
jQuery(document).ready(function($) {
    joints_wp_fixes()
    // AOS.init()  //Enable if loading AOS

    // Slick Slider
    if ($('.testimonial-item').length > 0) {
        $('.testimonial-item').slick({
            slidesToShow: 1,
            adaptiveHeight: true,
            infinite: true,
            fade: true,
            speed: 1000,
            prevArrow: $('.testimonial-nav-prev'),
            nextArrow: $('.testimonial-nav-next'),
        })
    }

    // Smooth Scroll
    if (!$('.page-template-template-07_Resources-Landing').length > 0) {
        $('a[href*="#"]:not([href="#"])').on('click', function() {
            if (
                location.pathname.replace(/^\//, '') ==
                    this.pathname.replace(/^\//, '') &&
                location.hostname == this.hostname
            ) {
                var target = $(this.hash)
                target = target.length
                    ? target
                    : $('[name=' + this.hash.slice(1) + ']')
                if (target.length) {
                    $('html, body').animate(
                        {
                            scrollTop: target.offset().top - 125,
                        },
                        1000,
                    )
                    return false
                }
            }
        })
    }

    // Match Height
    if ($('.card').length > 0) {
        $('.card').matchHeight({
            byRow: true,
        })

        $(window).on('resize'),
            function() {
                $('.card').matchHeight({
                    byRow: true,
                })
            }
    }

    watchGravityFormsUpload()
})
